import React, {Component} from 'react';
import classnames from 'classnames';

import './Template.scss';

export default class Template extends Component {
  handleClick = () => {
    const {id, selectTemplate} = this.props;
    selectTemplate(id);
  }

  render() {
    const {persona_image, occupation, id, template_id} = this.props;
    const templateClasses = classnames([
      'template',
      {'selected': template_id === id}
    ]);
    return (
      <div className={templateClasses} onClick={this.handleClick}>
        <img className="template-img" alt={occupation + ' persona'} src={persona_image}/>
        <div className="template-name"><span>{occupation === '' ? 'Blank': occupation}</span></div>
      </div>
    );
  }
};



// WEBPACK FOOTER //
// ./client/pages/persona/templateSelector/Template.jsx